<div [ngClass]="center ? 'modal-footer-center' : 'modal-footer'">
  <ng-content />
</div>
